






import { Vue, Component } from 'vue-property-decorator'
// import { Provider } from 'villus'
// import api from 'src/assets/api/gql'
import icons from 'src/assets/icons'
import 'src/assets/v-dev'
import 'src/assets/v-beta'

// import Component from 'vue-class-component'
Component.registerHooks([
  'setup'
])

// import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)

@Component({
  // components: {
  //   Provider
  // },
  // setup () {} // SETUP FOR APP WORKS ONLY HERE
})
export default class App extends Vue {
  // client = api.client

  created () {
    this.$q.iconMapFn = icons
  }
}
